import React, {useMemo} from 'react';
import {useHistory} from 'react-router-dom';

import {saveRule} from "./stab-api";
import config from '../../shared/config';

import {
	parseConfig,
	Form, FormGroup, Input,
	FilterSelector, RatesControls, validateRuleId
} from "./shared";


function CreateRule() {
	let cfg = config.get('ServiceConfiguration');
	let {filterSelectorsProps, rateControlsProps} = useMemo(() => parseConfig(cfg), [cfg]);
	let history = useHistory();

	return (
		<div className="cm-edit-rule-form">
			<h2>Create Rule</h2>
			<Form onSubmit={
				(e, state) => {
					let rule = state.getValues();
					let {ruleId} = rule;
					delete rule.ruleId;
					console.debug('Saving a rule', ruleId, rule);
					(async () => {
						await saveRule(ruleId, rule);
						history.push(`./rules/${ruleId}`);
					})();
				}
			}>
				<FormGroup htmlFor="ruleId" label="Rule identifier">
					<Input
						type="text" className="form-control"
						path="ruleId" validate={validateRuleId}
					/>
				</FormGroup>
				<FormGroup htmlFor="displayName" label="Display name">
					<Input
						type="text" className="form-control"
						path="displayName" placeholder="Display name for the rule"
					/>
				</FormGroup>

				{filterSelectorsProps.map(props => <FilterSelector key={props.key} {...props}/>)}
				{rateControlsProps.map(props => <RatesControls key={props.key} {...props}/>)}

				<button type="submit" className="btn btn-primary">Submit</button>
			</Form>
		</div>
	);
}


export default CreateRule;